var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { Box, Flex, Relative, Absolute, getPaletteColor } from 'pcln-design-system';
import { TripSummaryCard } from '@pcln/cards';
import { Plus } from 'pcln-icons';
import { HotelsOutlineGreenOnGreen, FlightsOutlineGreenOnGreen, CarsOutlineGreenOnGreen } from '@pcln/brand';
var IconWrapper = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "CrossSellCard__IconWrapper",
  componentId: "sc-1hobnds-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: 1px dashed ", ";\n"], ["\n  border: 1px dashed ", ";\n"])), function (props) {
  return getPaletteColor('success.dark')(props);
});
var getActionText = function (crossSellProduct) {
  switch (crossSellProduct) {
    case 'STAY':
      return 'Search Hotels';
    case 'FLY':
      return 'Search Flights';
    case 'DRIVE':
      return 'Search Cars';
  }
};
var getProductString = function (productType) {
  switch (productType) {
    case 'STAY':
      return 'hotel';
    case 'FLY':
      return 'flight';
    case 'DRIVE':
      return 'rental car';
  }
};
var IconComponent = function (_a) {
  var crossSellProduct = _a.crossSellProduct;
  switch (crossSellProduct) {
    case 'STAY':
      return React.createElement(HotelsOutlineGreenOnGreen, {
        size: '32px',
        title: 'hotel-icon'
      });
    case 'FLY':
      return React.createElement(FlightsOutlineGreenOnGreen, {
        size: '32px',
        title: 'flight-icon'
      });
    case 'DRIVE':
      return React.createElement(CarsOutlineGreenOnGreen, {
        size: '32px',
        title: 'car-icon'
      });
  }
};
export var CrossSellIcon = function (_a) {
  var crossSellProduct = _a.crossSellProduct;
  return React.createElement(Relative, null, React.createElement(IconWrapper, {
    p: 1,
    borderRadius: 'full'
  }, React.createElement(Flex, {
    px: 2,
    borderRadius: 'full',
    bg: 'highlight.light'
  }, React.createElement(Box, {
    mt: 2
  }, React.createElement(IconComponent, {
    crossSellProduct: crossSellProduct
  })))), React.createElement(Absolute, {
    bottom: 0,
    right: 0
  }, React.createElement(Flex, {
    alignItems: 'center',
    justifyContent: 'center',
    color: 'text.lightest',
    bg: 'success.dark',
    height: '16px',
    width: '16px',
    borderRadius: 'full'
  }, React.createElement(Plus, {
    color: 'text.lightest',
    size: 24
  }))));
};
/** @public */
var CrossSellCard = function (_a) {
  var className = _a.className,
    crossSellProduct = _a.crossSellProduct,
    primaryProduct = _a.primaryProduct,
    hoverBoxShadowSize = _a.hoverBoxShadowSize,
    showArrowRight = _a.showArrowRight,
    onClick = _a.onClick,
    handleSubmitCTA = _a.handleSubmitCTA,
    headingOverride = _a.headingOverride,
    captionOverride = _a.captionOverride,
    actionTextOverride = _a.actionTextOverride;
  return React.createElement(TripSummaryCard, {
    className: className,
    hoverBoxShadowSize: hoverBoxShadowSize,
    mediaNode: React.createElement(CrossSellIcon, {
      crossSellProduct: crossSellProduct
    }),
    mediaNodeBackgroundColor: 'transparent',
    heading: headingOverride || "Add a ".concat(getProductString(crossSellProduct), " to your trip"),
    caption: captionOverride || "Your ".concat(getProductString(primaryProduct), " booking unlocks up to 40% off ").concat(getProductString(crossSellProduct), "s"),
    actionText: actionTextOverride || getActionText(crossSellProduct),
    truncateHeading: true,
    showArrowRight: showArrowRight,
    onClick: onClick,
    handleSubmitCTA: handleSubmitCTA
  });
};
export default CrossSellCard;
var templateObject_1;